import { motion } from 'framer-motion'
import useTranslation from 'next-translate/useTranslation'

import { useCityPage } from '@/context/CityPageContext'
import { Callout } from '@/design-lib/components/Callout/Callout'
import { useSaveSearch } from '@/hooks/useSaveSearch'
import { GeoFilter } from '@/types/filter'
import { Filter } from '@/types/graphql-generated-types'

import { bottomUpAnimation } from '../framer-motion-variants'

import { floatingBannerPosition } from './styles.css'

type Props = {
  appliedGeoFilters: GeoFilter[]
  filters: Filter
  geoSlugs: string[]
  hasOnlyOneListing: boolean
}

const SaveSearchFloatingBanner: React.FC<Props> = ({ appliedGeoFilters, filters, geoSlugs, hasOnlyOneListing }) => {
  const {
    filters: { hasJustAppliedFilters },
  } = useCityPage()
  const { handleOpenSaveSearchModal } = useSaveSearch({ appliedGeoFilters, filters, geoSlugs })
  const { t } = useTranslation()

  const getText = (): string => {
    if (hasJustAppliedFilters) {
      return 'save-search:saveSearch-floatingBanner-textNewFilters'
    }
    if (hasOnlyOneListing) {
      return 'save-search:saveSearch-floatingBanner-text1result'
    }

    return 'save-search:saveSearch-floatingBanner-text'
  }

  return (
    <motion.div
      animate="animate"
      className={floatingBannerPosition}
      exit="exit"
      initial="initial"
      variants={bottomUpAnimation()}
    >
      <Callout
        ctaLabel={t('save-search:cta')}
        description={getText()}
        handleClick={handleOpenSaveSearchModal}
        icon="Bell"
        iconColor="orange600"
      />
    </motion.div>
  )
}

export default SaveSearchFloatingBanner
